module.exports = __webpack_public_path__ + "img/relief-desk.b123054e.png";